export default __webpack_public_path__ + "static/media/green-tea.48dc2ebf.png";